<template>
  <div class="fillcontain">
    <div class="table_container">

      <!--<el-row>-->
      <!--<el-col :span="8">-->
      <!--<el-input placeholder="请输入插件名称" v-model="pages.keyword" class="input-with-select">-->
      <!--</el-input>-->
      <!--</el-col>-->
      <!--<el-col :span="3">-->
      <!--<el-button @click="initData">搜索</el-button>-->
      <!--</el-col>-->
      <!--</el-row>-->
      <!--<br/>-->

      <br/>

      <el-table
        :data="pluginsTypes"
        style="width: 100%"
        default-expand-all
        v-loading="loading">
        <el-table-column
          type="expand">
          <template slot-scope="props">
            <el-table
              :data="plugins[props.row.type]"
              style="width: 100%"
              v-loading="loading">
              <el-table-column
                label="插件名"
                prop="name">
              </el-table-column>
              <el-table-column
                label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.used == false && scope.row.id == 0" style="color: red">未安装</span>
                  <span v-else-if="scope.row.used == false && scope.row.id > 0" style="color:blue">已安装</span>
                  <span v-else-if="scope.row.used == true" style="color: green">使用中</span>
                </template>
              </el-table-column>
              <el-table-column
                label="备注"
                :show-overflow-tooltip="true"
                prop="note">
              </el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <div>
                    <el-button
                      size="mini"
                      type="warning"
                      v-if="scope.row.used == false && scope.row.id == 0"
                      @click="install(scope.row)">
                      安装
                    </el-button>
                    <div v-else>
                      <el-button
                        size="mini"
                        type="danger"
                        @click="uninstall(scope.row)">
                        卸载
                      </el-button>
                      <el-button
                        size="mini"
                        type="success"
                        @click="setting(scope.row)">
                        配置
                      </el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="插件">
        </el-table-column>
      </el-table>




      <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close">
        <el-form :model="plugin">
          <el-form-item :label="item.labelName" label-width="100px" v-if="item.displayType == 1" v-for="(item,key) in params" :key="key">
              <el-input v-model="item.cvalue" auto-complete="off" v-if="item.eleType == 1"></el-input>
              <div v-else-if="item.eleType == 2">
                <el-upload
                  v-if="item.cvalue == null || item.cvalue == ''"
                  :action="uploadUrl+'?key='+key"
                  :on-success="handleSuccess"
                  :limit="1">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <div v-else>
                  已上传({{item.cvalue.substr(item.cvalue.lastIndexOf("/")+1)}})  <el-button size="small" type="danger" @click="item.cvalue = ''">删除</el-button>
                </div>
              </div>
              <div v-else-if="item.eleType == 4">
                <el-switch
                  v-model="item.cvalue"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="开启"
                  inactive-text="关闭"
                  active-value="true"
                  inactive-value="false">
                </el-switch>
              </div>
            <el-input-number v-else-if="item.eleType == 5" v-model="item.cvalue" auto-complete="off"></el-input-number>
            <el-input v-else-if="item.eleType == 6" type="textarea" :rows="5" v-model="item.cvalue" auto-complete="off"></el-input>
            <el-alert
              v-if="item.placeholder"
              :title="item.placeholder"
              type="success">
            </el-alert>
          </el-form-item>
          <el-form-item label="启用状态" label-width="80px">
            <el-switch
              v-model="plugin.used"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="启用"
              inactive-text="禁用"
              active-value="true"
              inactive-value="false">
            </el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        uploadUrl:window.server.baseUrl+'/common/imageUpload',
        store_id:0,
        loading:false,
        qrcodeurl:"",
        tmpRow:null,
        plugin:{
          id:0,
          params:"",
          used:"1",
        },

        params:[],
        dialog:{
          dialogFormVisible:false,
          title:"安装插件",
          close:false,
        },
        // pages:{
        //     offset: 0,
        //     pageSize: 10,
        //     page: 1,
        //     total: 0,
        //     keyword:"",
        // },
        pluginsTypes: [],
        plugins:[],

      }
    },
    created(){
      this.store_id = this.$route.query.store_id;
      var storage = window.localStorage;
      this.token = storage["access_token"];
      this.initData();
    },
    methods: {
      initData(){
        this.loading = true;
        var that = this;
        that.$api.get('/main_store/plugins/'+this.store_id, that.pages, response => {
          if (response.status >= 200 && response.status < 300) {
            var res = response.data;
            if (res.code == 0) {

              that.pluginsTypes = res.data.pluginsTypes;
              that.plugins = res.data.plugins;

            }else{
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: "服务器维护中",
              type: 'error'
            });
          }
          this.loading = false;
        });
      },
      handleSuccess(response,file, fileList) {
        //file.id = response.ids[0];
        //file.ext = response.exts[0];
        console.log(file);
        this.params[response.key].cvalue = response.md5[0];
      },
      // handleSizeChange(val) {
      //     console.log(`每页 ${val} 条`);
      // },
      // handleCurrentChange(val) {
      //     this.pages.page = val;
      //     this.pages.offset = (val - 1)*this.pages.pageSize;
      //     this.initData()
      // },
      // statusFormat(row,column){
      //     return row.status == 2?"上架":"下架";
      // },


      install(row) {
        this.$confirm('确定要安装插件【'+row.name+'】吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          var that = this;
          that.$api.post('/main_store/plugins/' + this.store_id + '/install/'+row.uuid, null, response => {
            if (response.status >= 200 && response.status < 300) {
              console.log(response.data);
              var res = response.data;
              if (res.code == 0) {
                this.$message({
                  message: '插件安装安装成功',
                  type: 'success'
                });
                row.id=res.data.plugin.id;
              }else{
                this.$message({
                  message: res.msg,
                  type: 'warning'
                });
              }
            } else {
              this.$message({
                message: "服务器维护中",
                type: 'error'
              });
            }

          });

          this.loading = false;
        }).catch((res) => {
          console.log(res);
          /**
          this.$message({
            message: "服务器维护中!",
            type: 'error'
          });
           **/
        });
      },
      uninstall(row) {
        this.$confirm('确定要卸载插件【'+row.name+'】吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          var that = this;
          that.$api.delete('/main_store/plugins/' + this.store_id + '/uninstall/'+row.uuid, null, response => {
            if (response.status >= 200 && response.status < 300) {
              console.log(response.data);
              var res = response.data;
              if (res.code == 0) {
                this.$message({
                  message: '插件安装安装成功',
                  type: 'success'
                });
                row.used=false;
                row.id=0;
              }else{
                this.$message({
                  message: res.msg,
                  type: 'warning'
                });
              }
            } else {
              this.$message({
                message: "服务器维护中",
                type: 'error'
              });
            }

          });

          this.loading = false;
        }).catch(() => {
          /**
          this.$message({
            message: "服务器维护中!",
            type: 'error'
          });
           **/
        });
      },
      setting(row) {
        this.tmpRow = row;
        this.dialog.title = "配置:"+row.name;
        this.plugin.id = row.id;
        this.plugin.name = row.name;
        this.plugin.used = ""+row.used;
        this.params = row.pluginsParams;
        this.dialog.dialogFormVisible = true;
      },

      handleSave() {
        this.loading = true;
        var that = this;
        that.plugin.params = JSON.stringify(this.params);
        that.$api.put('/main_store/plugins/' + this.store_id + '/setting/'+that.plugin.id, that.plugin, response => {
          if (response.status >= 200 && response.status < 300) {
            console.log(response.data);
            var res = response.data;
            if (res.code == 0) {
              this.$message({
                message: '配置成功',
                type: 'success'
              });

              this.tmpRow.used=res.data.plugin.used;
              this.tmpRow.paramsStr=res.data.plugin.paramsStr;
              this.dialog.dialogFormVisible = false;
            }else{
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: "服务器维护中",
              type: 'error'
            });
          }

        });

        this.loading = false;
      },

    },
  }
</script>

<style lang="less">
  @import '../../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .table_container{
    padding: 20px;
    text-align: left;
  }
  .Pagination{
    display: flex;
    justify-content: flex-start;
    margin-top: 8px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/mainStore/StorePlugins.vue